import { Component } from '@angular/core';
import { quickFade } from 'src/app/component/shared/others/animation/quickFade';
import { ProgressTimetableService } from 'src/app/component/shared/services/progress-timetable.service';

@Component({
  selector: 'app-progress-timetable',
  templateUrl: './progress-timetable.component.html',
  styleUrls: ['./progress-timetable.component.scss'],
  animations: [quickFade],
})
export class ProgressTimetableComponent {
  constructor(public progressTimetableService: ProgressTimetableService) {}
  expanded = true;

  toggleExpand(state: boolean) {
    this.expanded = state;
  }

  trackItem(index, item) {
    return item.id;
  }
}
